// FormField.tsx
import MDInput from "components/MDInput";
import { StandardTextFieldProps } from "@mui/material";
import React from "react";

interface Props extends StandardTextFieldProps {
  label?: string;
  inputProps?: any; // AutocompleteがinputPropsを渡すので必須
  [key: string]: any;
}

const FormField = React.forwardRef<HTMLInputElement, Props>(
  (
    { label = " ", InputProps = {}, InputLabelProps, inputProps, ...rest },
    ref
  ): JSX.Element => {
    return (
      <MDInput
        variant="standard"
        label={label}
        fullWidth
        inputRef={ref}
        inputProps={inputProps}
        InputProps={InputProps}
        InputLabelProps={{ shrink: true, ...InputLabelProps }}
        {...rest}
      />
    );
  }
);

FormField.displayName = "FormField";

export default FormField;
